<template>
  <div class="card-traceability">
    <card
      v-if="card.visible"
      :id="card.id"
      :key="card.id"
      :title="card.title"
      :capitalize-subtitle="card.capitalizeSubtitle"
      :transparent-card="card.transparentCard"
      :subtitle-regular="getUpdateTime.phrase"
      :subtitle-highlight="getUpdateTime.time + ' (Período 7 dias)'"
      :buttons="card.buttons"
      :class="[{ 'card-disabled': card.disabled }, card.class]"
      @btnClickAction="!card.disabled && go(card.buttons[0].action)"
    >
      <div>
        <div class="wrapper">
          <img
            src="/static/images/tubos.svg"
            alt="icone-tubos"
          />
          <div>
            <p class="title">total de lotes</p>
            <p class="value batch">
              {{ totalBatches }}
            </p>
          </div>
        </div>
        <div class="wrapper">
          <img
            src="/static/images/caminhao.svg"
            alt="icone-caminhao"
          />
          <div>
            <p class="title">lotes Aguardando retirada</p>
            <p class="value batch-waiting">
              {{ batchesWaitingForTransport }}
            </p>
          </div>
        </div>
        <div class="wrapper">
          <img
            src="/static/images/caminhao-amostras.svg"
            alt="icone-caminhao-amostras"
          />
          <div>
            <p class="title">lotes Em trânsito</p>
            <p class="value batch-in-transit">
              {{ batchesInTransit }}
            </p>
          </div>
        </div>
        <div class="wrapper">
          <img
            src="/static/images/predio.svg"
            alt="icone-predio"
          />
          <div>
            <p class="title">lotes Em trânsito entre Ntos</p>
            <p class="value batch-in-transit-nto">
              {{ batchesInTransitNTOs }}
            </p>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import moment from 'moment'

import Card from '../Card'
import batchService from '@/api/batch'

export default {
  name: 'CardTraceability',
  components: { card: Card },
  data() {
    return {
      totalBatches: 0,
      batchesWaitingForTransport: 0,
      batchesInTransit: 0,
      batchesInTransitNTOs: 0,
    }
  },
  computed: {
    ...mapGetters(['getUpdateTime', 'toggle']),
    card() {
      return {
        id: 'traceability',
        visible: true,
        disabled: !this.toggle.sampleTraceability,
        title: 'Rastreabilidade - logística',
        class: 'logistic',
        buttons: [
          {
            text: 'ACESSAR DETALHES',
            style: 'btn-primary',
            action: '/traceability/logistic/batches',
            visible: !this.toggle.covax && this.toggle.results,
          },
        ],
      }
    },
  },
  mounted() {
    this.fetchBatchData()
  },
  methods: {
    fetchBatchData() {
      batchService.getBatchStatus({
          startDate: moment(new Date()).subtract(7, 'days').format('YYYY-MM-DD'),
          endDate: moment(new Date()).format('YYYY-MM-DD')
        }).then(response => {
        const { total, waiting, inTransfer, inTransferBetweenNTO } = response.data
        this.batchesWaitingForTransport = waiting
        this.totalBatches = total
        this.batchesInTransit = inTransfer
        this.batchesInTransitNTOs = inTransferBetweenNTO
      })
    },
    go(path) {
      this.$router.push({
        path: path,
        query: {
          startDate: moment(new Date()).clone().subtract(7, 'days').format('YYYY-MM-DD'),
          endDate: moment(new Date()).format('YYYY-MM-DD')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .card-traceability {
    flex: 1;
  }
}

@media (max-width: 1024px) {
  .card-traceability {
    margin: 20px 0;

    .md-card {
      padding-bottom: 20px;
    }
  }
}

.wrapper {
  margin-top: 24px;

  .title {
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 600;
    margin: 0;
    line-height: 0;
    color: #818181;
  }

  .value {
    font-size: 27px;
    font-weight: 600;
    margin-top: 12px;
  }

  .batch {
    color: #00b5cc;
  }

  .batch-waiting {
    color: #f78e26;
  }

  .batch-in-transit {
    color: #52cc9c;
  }

  .batch-in-transit-nto {
    color: #8ad4df;
  }

  img {
    margin-right: 8px;
  }
}

.logistic {
  .graphic-legend {
    overflow-y: scroll;
    height: 235px;
    width: 100% !important;
    margin-left: 40px !important;
  }

  .count-indicator__count {
    &.count-indicator__count--bigger {
      p {
        font-size: 24px;
      }
    }
  }

  .count-indicator__description--bigger {
    width: 100% !important;
  }
}
</style>
